/**
 * ONE POP-UP PER LOGIN (2026-10-09, announcements spec).
 *
 * Three things can open on their own when someone arrives: the Action
 * Items modal (critical items), an announcement, and the Discount
 * Reminder. Stacked, they get clicked away unread. The first to claim the
 * slot for this browser session wins; the others wait for the next login.
 * Priority comes from timing: Action Items claims as soon as its data
 * loads, the announcement waits a moment before claiming, and the
 * Discount Reminder waits for the announcement's decision.
 *
 * Stored in sessionStorage, which survives logout/login in the same tab,
 * so login, company switch and logout call resetLoginModal() to free the
 * slot for the next person. If storage is unavailable, every claim
 * succeeds (the old behaviour).
 */
export type LoginModal = "action-items" | "announcement" | "discount";

const KEY = "gm.loginModal";

export function claimLoginModal(name: LoginModal): boolean {
  try {
    const current = sessionStorage.getItem(KEY);
    if (current && current !== name) return false;
    sessionStorage.setItem(KEY, name);
    return true;
  } catch {
    return true;
  }
}

export function loginModalHolder(): LoginModal | null {
  try {
    return (sessionStorage.getItem(KEY) as LoginModal) || null;
  } catch {
    return null;
  }
}

/** Frees the slot. Call on login, company switch and logout. */
export function resetLoginModal(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // storage unavailable: nothing to reset
  }
}
